<mat-card class="card-web" appearance="outlined">
    <mat-card-header>
    <div class="card-header-web">
      <img class="card-provider-image-web" [src]="photo || environment.default_provider_photo_url" alt="Provider Photo" />
      <div class="card-provider-wait-time-container-web">
        <div class="card-provider-book-as-soon-as-web" *ngIf="availability!=null && waitTime!=null && waitTime!=''">
            {{soonAsText}}
        </div>
        <div *ngIf="availability!=null && waitTime!=null && waitTime!=''" class="card-provider-availability-web">
            {{waitTime}}
        </div>
        <div *ngIf="availability == null" class="card-provider-availability-web" style="width: 124px; text-align: left;">
          {{noAvailabilityStr}}
        </div>
      </div>
    </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-web">
      <mat-card-title *ngIf="name.length <= 25" class="card-provider-title-web">{{name}}</mat-card-title>
      <mat-card-title *ngIf="name.length > 25" class="card-provider-title-long-web">{{name}}</mat-card-title>
      <mat-card-subtitle class="card-provider-subtitle-web truncate-text" [title]="specialties">{{specialties}}</mat-card-subtitle>
      <div class="card-provider-city-web">
        <svg width="7.89" height="13.6" viewBox="0 0 7.89 13.6" style="padding-right: 6px;" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="3.94737" cy="3.77776" rx="3.94737" ry="3.77776" fill="#959595"/>
            <line x1="3.65771" y1="6.04443" x2="3.65771" y2="13.6" stroke="#959595"/>
        </svg>
        <div>{{city}}</div>
      </div>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-web">
        <div *ngIf="distance != null && distance != ''" class="card-provider-detail-bottom-left-web">
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.85468 0L5.21832 9.12723L3.99545 5.13755L0.0221554 4.05578L8.85468 0Z" fill="#959595"/>
            </svg>
            {{distance}} {{milesAwayText}}
        </div>
        <div *ngIf="distance == null || distance == ''" class="card-provider-detail-bottom-left-web"></div>
        <button mat-button *ngIf="availability!=null || (isOpenScheduling != null && isOpenScheduling == true && departmentId != null)" class="action-button-primary"  style="height: 39px;" (click)="bookNow()">{{scheduleText}}</button>
        <div *ngIf="availability == null && (isOpenScheduling == null || isOpenScheduling != true)" class="card-provider-phone-web">
            {{phone}}
        </div>
    </mat-card-actions>
</mat-card>
